import { useSelector } from 'react-redux';
import { useCallback } from 'react';

export const useFeatureFlags = () => {
  const permissions = useSelector((state) => state.loyalty.admin.permissions);

  const hasFeatureFlag = useCallback((flagName) => {
    if (!permissions?.featureFlags) return false;
    return permissions.featureFlags[flagName] === true;
  }, [permissions]);

  const getQuotaLimit = useCallback((quotaName) => {
    if (!permissions?.quotas) return null;
    return permissions.quotas[quotaName];
  }, [permissions]);

  const isQuotaExceeded = useCallback((quotaName, currentUsage) => {
    const quota = getQuotaLimit(quotaName);
    if (!quota || typeof quota.limit !== 'number') return false;
    return currentUsage >= quota.limit;
  }, [getQuotaLimit]);

  const getFeatureFlags = useCallback(() => {
    return permissions?.featureFlags || {};
  }, [permissions]);

  const getQuotas = useCallback(() => {
    return permissions?.quotas || {};
  }, [permissions]);

  return {
    permissions,
    hasFeatureFlag,
    getQuotaLimit,
    isQuotaExceeded,
    getFeatureFlags,
    getQuotas,
  };
};

export default useFeatureFlags; 